module.exports = __webpack_public_path__ + "static/media/old_age_crop.4989689f.jpg";